// alertForwardColumns.tsx
import React from 'react';
import type { ColumnsType } from 'antd/es/table';
import type { MenuProps } from 'antd';
import { AlertForwardRule } from './types';
import { StyledDropdown, ActionButton, MoreIcon } from './styled';

type ColumnDeps = {
  mutatingId: number | null;
  isMutating: boolean;
  handleMenuClick: (key: string, record: AlertForwardRule) => void;
};

export const getAlertForwardColumns = ({
  mutatingId,
  isMutating,
  handleMenuClick,
}: ColumnDeps): ColumnsType<AlertForwardRule> => [
  {
    title: 'Name',
    dataIndex: 'name',
    width: '80%',
    sorter: (a, b) => a.name.localeCompare(b.name),
    defaultSortOrder: 'ascend',
    showSorterTooltip: false,
  },
  {
    title: 'Status',
    dataIndex: 'isEnabled',
    width: '10%',
    sorter: (a, b) =>
      (a.isEnabled ? 'Enabled' : 'Disabled').localeCompare(b.isEnabled ? 'Enabled' : 'Disabled'),
    render: (isEnabled: boolean) => (isEnabled ? 'Enabled' : 'Disabled'),
  },
  {
    title: '',
    dataIndex: 'actions',
    align: 'center',
    width: '5%',
    render: (_, record) => {
      const actionMenuItems: MenuProps['items'] = [
        { key: 'edit', label: 'Edit' },
        { key: 'duplicate', label: 'Duplicate' },
        record.isEnabled
          ? { key: 'disable', label: 'Disable' }
          : { key: 'enable', label: 'Enable' },
        { type: 'divider' },
        { key: 'delete', danger: true, label: 'Delete' },
      ];

      return (
        <StyledDropdown
          menu={{
            items: actionMenuItems,
            style: { textAlign: 'left' },
            onClick: ({ key }) => handleMenuClick(key, record),
          }}
          trigger={['click']}
          getPopupContainer={(node) => node?.parentElement ?? document.body}
        >
          <ActionButton
            aria-label={`Actions for ${record.name}`}
            loading={record.id === mutatingId && isMutating}
            icon={<MoreIcon />}
          />
        </StyledDropdown>
      );
    },
  },
];
